(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/emp-video-player/assets/javascripts/init.js') >= 0) return;  svs.modules.push('/components/components/emp-video-player/assets/javascripts/init.js'); "use strict";

var _svs$components$emp_v = svs.components.emp_video_player.contentLoader,
    loadVideo = _svs$components$emp_v.loadVideo,
    getMeta = _svs$components$emp_v.getMeta;
var loadView = svs.components.emp_video_player.helpers.client.loadView;

function setupVideo(element) {
  var parent = element.parentNode;
  var attributes = parent.attributes;
  var options = {
    assetId: attributes['data-assetid'] && attributes['data-assetid'].value,
    businessUnit: attributes['data-businessunit'] && attributes['data-businessunit'].value,
    customer: attributes['data-customer'] && attributes['data-customer'].value
  };
  getMeta(options).then(function (result) {
    loadView(element, 'thumbnail', result, loadVideo);
    return undefined;
  }).catch(function () {
    loadView(element, 'missing');
  });
}

function init() {
  var videoElements = document.getElementsByClassName('js-emp-placeholder');

  for (var i = 0; i < videoElements.length; i++) {
    var element = videoElements[i];
    setupVideo(element);
  }

  svs.events.subscribe('/video/banner', function (options) {
    var banner = options.banner,
        bannerElement = options.bannerElement;

    if (banner && banner.video && banner.video.type === 'redbee') {
      var _element = bannerElement[0].querySelector('.js-emp-placeholder');

      setupVideo(_element);
    }
  });
}

init();
 })(window);